import React, { useCallback, useContext } from 'react'

import {
  ImageContainer,
  ImageOverlayContainer,
} from './Common'
import DatesVariant from './Common/DatesVariant'
import SummaryCardImage from './SummaryCardImage'

import HeightFillingImage from 'components/Common/HeightFillingImage'
import ProductTypeLabel from 'LuxKit/Label/ProductTypeLabel'
import { OFFER_TYPE_CRUISE } from 'constants/offer'
import TripItemSummary from 'tripPlanner/components/TripModal/TripItems/Summary'
import TripContext, { useTripId } from 'tripPlanner/contexts/TripContext'
import useImmersiveModeHandlers from 'tripPlanner/hooks/useImmersiveModeHandlers'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { CruiseItem } from 'tripPlanner/types/tripItem'
import {
  getCruiseV2OfferUrl,
} from 'tripPlanner/utils'
import { tripItemSelectionId } from 'tripPlanner/utils/itemSelection'

interface Props {
  item: CruiseItem
}

function CruiseV2Card({ item }: Props) {
  const {
    startPlace,
    isBooked,
    name,
    type,
    startDate,
    endDate,
    startDay,
    endDay,
  } = item

  const openModal = useOpenModal()
  const tripId = useTripId()

  const tripContext = useContext(TripContext)
  const canEdit = tripContext?.permissions.canEdit ?? false
  const { setImmersiveMode } = useImmersiveModeHandlers()

  const handleClick = useCallback(() => {
    if (isBooked) {
      openModal(TripItemSummary, { item })
    }
    if (canEdit) {
      setImmersiveMode({ tripId, sectionId: tripItemSelectionId(item.id) })
    }
  }, [canEdit, isBooked, item, openModal, setImmersiveMode, tripId])

  if (item.savedItemData?.offerType !== 'cruise') {
    return null
  }

  const imageId = item.savedItemData.imageId

  const offerUrl = getCruiseV2OfferUrl(item)

  return (
    <>
      {imageId && (
        <ImageContainer>
          <HeightFillingImage id={imageId} />
          <ImageOverlayContainer>
            <ProductTypeLabel productType={OFFER_TYPE_CRUISE} />
          </ImageOverlayContainer>
        </ImageContainer>
      )}
      {!imageId && (
        <SummaryCardImage
          place={startPlace}
          tripId={item.tripId}
          tripItemId={item.id}
        />
      )}
      <DatesVariant
        region={startPlace.region}
        name={name}
        startDate={startDate}
        endDate={endDate}
        type={type}
        isBooked={isBooked}
        onClick={handleClick}
        to={isBooked ? undefined : offerUrl}
        linksToOffer={!isBooked}
        canEdit={canEdit && !isBooked}
        startDay={startDay}
        endDay={endDay}
      />
    </>
  )
}

export default CruiseV2Card
